import * as Yup from "yup";

import { LocationPreferenceEnum } from "@/types/candidate";

import { locationPreferenceValues } from "@/constants/candidates";

export const jobAddFormSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  company: Yup.object().required("Required"),
  handpick_company: Yup.object().when("is_codemonk_handpick", {
    is: "true",
    then: Yup.object().required("Required").typeError("Required"),
  }),
  job_role: Yup.object().required("Required").typeError("Required"),
  min_exp: Yup.number()
    .required("Required")
    .min(0, "Invalid")
    .typeError("Required"),
  // .lessThan(Yup.ref("max_exp"), "Min must be less than max"),
  max_exp: Yup.number().when("is_experience_range_any", {
    is: false,
    then: Yup.number().required("Required").typeError("Required"),
    otherwise: Yup.number().notRequired(),
  }),
  negotiable_min_exp: Yup.number().when("is_min_exp_negotiable", {
    is: true,
    then: Yup.number().required("Required").typeError("Required"),
  }),
  joining_availability_days__form_value: Yup.object()
    .required("Required")
    .typeError("Required"),

  negotiable_min_joining_availability__form_value: Yup.object().when(
    "is_joining_availability_negotiable",
    {
      is: true,
      then: Yup.object().required("Required").typeError("Required"),
    },
  ),
  negotiable_max_salary: Yup.number().when("is_max_salary_negotiate", {
    is: true,
    then: Yup.number().required("Required").typeError("Required"),
  }),
  min_salary: Yup.number()
    .required("Required")
    .min(0, "Invalid")
    .lessThan(Yup.ref("max_salary"), "Min must be less than max"),
  max_salary: Yup.number().required("Required"),

  openings: Yup.number().required("Required").typeError("Required"),
  work_preference_new__form_value: Yup.object().test(
    (data: Record<string, boolean>) => Object.values(data).includes(true),
  ),
  location_new: Yup.array().when("work_preference_new__form_value", {
    is: (data: Record<LocationPreferenceEnum, boolean>) =>
      data &&
      (data[locationPreferenceValues.Hybrid] ||
        data[locationPreferenceValues.Onsite]),
    then: Yup.array().min(1, "Atleast one location is required"),
  }),
});

export const jobUpdateFormSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  company: Yup.object().required("Required"),
  handpick_company: Yup.object().when("is_codemonk_handpick", {
    is: "true",
    then: Yup.object().required("Required").typeError("Required"),
  }),
  min_exp: Yup.number()
    .required("Required")
    .min(0, "Invalid")
    .lessThan(Yup.ref("max_exp"), "Min must be less than max"),
  max_exp: Yup.number().required("Required"),
  min_salary: Yup.number()
    .required("Required")
    .min(0, "Invalid")
    .lessThan(Yup.ref("max_salary"), "Min must be less than max"),
  max_salary: Yup.number().required("Required"),

  openings: Yup.number().required("Required"),
  work_preference_new__form_value: Yup.object().test(
    "atleast one",
    "Please select atleast one location type",
    (data: Record<string, boolean>) =>
      Object.values(data).some((item) => item === true),
  ),
  location_new: Yup.array().when("work_preference_new__form_value", {
    is: (data: Record<LocationPreferenceEnum, boolean>) =>
      data &&
      (data[locationPreferenceValues.Hybrid] ||
        data[locationPreferenceValues.Onsite]),
    then: Yup.array().min(1, "Atleast one location is required"),
  }),
});
